<template>
  <div class="langSelect">
    <span>{{ $t('header.changeLanguage') }}</span>
    <div class="languages">
      <a
        v-for="(language, idx) in languages"
        :key="idx"
        role="button"
        tabindex="0"
        href="javascript:void(0);"
        class="tooltipItem"
        :aria-label="`${$t('header.changeLanguage')} ${language}`"
        @blur="handleBlur"
        @click.prevent="loadLangBridge(language)"
        @keydown.space.exact.prevent="loadLangBridge(language)"
      >
        <svg
          :key="idx"
          class="flag"
          aria-hidden="true"
          width="30px"
          height="23px"
          viewBox="0 0 30 23"
        >
          <use :xlink:href="`#flag-${language}`" :href="`#flag-${language}`" />
        </svg>

        <span>{{ language }}</span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { i18n } from '@/main.js';
import header from '@/store/header';
import { loadLanguage } from '@/translations/translation-setup';

const availableLanguages = ['sk', 'en'];

// COMPUTED
const languages = computed(() => {
  return availableLanguages.filter(
    (language: string) => language !== i18n.global.locale.value,
  );
});

// METHODS
// loadLanguge bridge
const loadLangBridge = (lang: string) => {
  loadLanguage(lang);
};

// blur out of dropdown
const handleBlur = () => {
  // if its without small timeout, blur jumps before selection and correct item is not selected
  setTimeout(() => {
    if (!(document.activeElement as any).classList.contains('tooltipItem')) {
      header.settingsOpened = false;
    }
  }, 100);
};
</script>

<style lang="scss">
@use '@/assets/scss/variables.scss';
@use '@/assets/scss/mixins.scss';

.langSelect {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @include mixins.max-breakpoint('md') {
    flex-direction: column;
    @include mixins.fontSize(14px);
  }

  .languages {
    display: flex;
    align-items: center;
    flex-direction: column;

    text-transform: uppercase;

    a {
      display: flex;
      align-items: center;

      color: inherit;
      text-decoration: none;
      line-height: 0;
      font-weight: 600;

      outline: none;

      &:focus,
      &:active,
      &:hover {
        text-decoration: underline;
      }

      .flag {
        width: mixins.calculateRem(25px);
        margin-right: mixins.calculateRem(10px);
        border-radius: variables.$border-radius + 2;
      }

      &:not(:last-child) {
        margin-bottom: mixins.calculateRem(10px);

        @include mixins.max-breakpoint('md') {
          margin-bottom: 0;
        }
      }

      &:first-child {
        margin-top: mixins.calculateRem(2px);
      }

      @include mixins.max-breakpoint('md') {
        margin-right: mixins.calculateRem(variables.$spacingHeaderContent);
      }
    }

    @include mixins.max-breakpoint('md') {
      margin-top: mixins.calculateRem(variables.$spacingHeaderContent * 0.33);
      flex-direction: row;
    }
  }
}
</style>
